import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common-service';
import { SafeHtml } from '@angular/platform-browser';
import { SanitizationService } from '../sanitization.service';
import { MdEditorOption } from 'ngx-markdown-editor/public_api';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import { convert } from "html-to-text";


@Component({
  selector: 'app-kh-doc-page',
  templateUrl: './kh-doc-page.component.html',
  styleUrl: './kh-doc-page.component.scss'
})
export class KhDocPageComponent implements OnInit {
  documentName: any;
  file_name: any;
   selectedfilecontent:any="";
   selectedVersionfilecontent:any='';
  isEditMode: boolean | undefined;
  modalloader!: boolean;
  isPreviewMode!: boolean;
  public mode: string = 'editor';
  public editorOptions: MdEditorOption = {
    showPreviewPanel: true,
    resizable: true,
    fontAwesomeVersion: '6',
    markedjsOpt: {
      sanitize: true
    }
  };
  showleftMenu: boolean=true;
  documentId: any;
  collectionId: any;
  generateqns: any[]=[];
  versionDetail: any[] = [];
  knowledgegpaDetail: any[]=[];
  metadata: any="";
  showuploadmodal: boolean=false;  auditDetail: any[]=[];
  isbookmarked: boolean= false;
  public editableDocument: any = { content: '' };
  collection_to_upload_doc: any;
  files: File[] = [];
  documents:any[]=[];
  private httpClient: HttpClient;
  uploadloader: boolean= false;
  categoryPath: any[] = [];
  relatetedDocList: any[]=[];
  showSelect: boolean=false;
  DocumentList: any[]=[];
  selectedDocuments: any[]=[];
  username: any ;
  statuses: string[] = [];
  selectedStatus: string = 'All';
  viewversion: boolean=false;
  versionId: any;
  bookmarkedList: any[]=[];
  versionmodalloader:boolean=false;
  displayRemarkPopup: boolean = false;
  remark: string = '';
  rows: number = 10;
  totalrecords = 0
  first: number = 0;
  pagenumber: number = 1;
  loader: boolean=false;
  filteredDocuments:any[]=[];
  filterStatus: string = 'All';
  searchTerm: string = '';
  keywordSearchlogs: any[]=[];
   highlightText:any = '';
   private shouldScrollToHighlight = false;
  @ViewChild('contentToConvert', { static: false }) content!: ElementRef;
  constructor(private route:ActivatedRoute,private router: Router, handler: HttpBackend,private api:CommonService, public sanitizeService:SanitizationService,private messageService: MessageService){
    this.httpClient = new HttpClient(handler);   
}
    

ngOnInit(){
  const data = this.api.getData();
  if (data) {
    this.documentId=data.documentId;
    this.collectionId=data.collectionId;
  } else {
    console.log('No data available');
  }
  this.route.params.subscribe(params => {
    this.documentName = params['documentname']
    this.file_name=params['doc']
  });
  this.fetchFilecontent(this.documentId,false);
  this.username=localStorage.getItem('username');
  this.fetchStatus();
  this.fetchDocuments();
}
onClickfile(file:any){
  // reset highlight state so it won’t apply to next file
  if (history.state && history.state['highlight']) {
    // create a shallow copy of state and remove highlight
    const newState = { ...history.state };
    delete newState['highlight'];
    history.replaceState(newState, '');
  }
  this.file_name=file.file_name;
  this.fetchFilecontent(file.id,false);
}
fetchFilecontent(file_Id:any,editMode:boolean){
    this.isEditMode = editMode;
    this.selectedfilecontent = '';
    this.modalloader=true;
    this.isPreviewMode=false;
    this.documentId=file_Id;
    const endpoint =  `document/${this.collectionId}/${this.documentId}`;
    this.api.getMethod(endpoint).subscribe({
      next:(data:any)=>{this.modalloader = false;
      this.selectedfilecontent = data.data;
      this.metadata = { ...this.selectedfilecontent.metadata }; 
      this.metadata.username = this.username; 
      const categoryId = this.metadata.category;
      this.isbookmarked=this.selectedfilecontent.isBookmarked;
      this.categoryPath = this.getCategoryPath(categoryId, this.metadata.categoryTree);
      if (!editMode) {
        const highlightText = this.getHighlightFromState();
        this.highlightText = highlightText

        // mark for scrolling after render
          if (highlightText) {
            this.shouldScrollToHighlight = true;
          }
      }
      if (editMode) {
        this.editableDocument = { ...data, content: data.data.content };
      }},
      error:(err:any)=>{     
       this.messageService.add({ severity: 'error', detail: err.error.message });
    }
  });
    
}

  ngAfterViewChecked() {
    if (this.shouldScrollToHighlight) {
      this.shouldScrollToHighlight = false; // reset so it runs once
      const firstHighlight = document.querySelector('.highlight') as HTMLElement | null;
      if (firstHighlight) {
        firstHighlight.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
// helper to check highlight state
private getHighlightFromState(): string | null {
  const nav = this.router.getCurrentNavigation();
  if (nav?.extras.state && nav.extras.state['highlight']) {
    return nav.extras.state['highlight'];
  } else if (history.state && history.state['highlight']) {
    return history.state['highlight'];
  }
  return null;
}
private fetchDocuments(): void {
  const payload = {
    collection_name: this.documentName,  
  };
  this.api.fetchDocument(payload).subscribe((data: any) => {
    this.documents = data[this.documentName];
    this.totalrecords = data.totalActiveDocuments;
    this.filterDocuments();
    this.loader = false;
  });
}
private filterDocuments(): void {
  let filteredByStatus = this.selectedStatus === 'All' 
    ? this.documents 
    : this.documents.filter(doc => doc.status === this.selectedStatus);
  this.filteredDocuments = this.searchTerm.trim() 
    ? filteredByStatus.filter(doc => 
        doc.file_name.toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    : filteredByStatus;
}
searchByName() {
if (this.searchTerm.trim() === '') {
  this.fetchDocuments();
} else if(this.searchTerm.length>2){
    const payload = {
    collection_name: this.documentName, 
  };
  this.api.fetchDocument(payload).subscribe((data: any) => {
    this.documents = data[this.documentName];
    this.filterDocuments();
    this.loader = false;  });   
    
}
}

fetchAllDocuments() { 
  const payload = { collection_name: this.documentName };     
    this.api.postMethod('get-collection-documents', payload).subscribe((data: any) =>{
      this.documents = data[this.documentName];  
    });
}

onPageChange(event:any) {
  this.loader=true
  this.first = event.first;
  this.pagenumber = event.page+1;
  this.fetchDocuments();
}
getCategoryPath(categoryId: number, categoryTree: any[]): any[] {
  let path = [];
  if(categoryTree!=null){
  let currentCategory = categoryTree.find(c => c.id === categoryId);
  while (currentCategory) {
    path.unshift(currentCategory); // Insert at the start to build from parent to child
    currentCategory = categoryTree.find(c => c.id === currentCategory.parent_id);
  }
  }
  return path;
}
cancelEdit(){
 this.isEditMode=false
}
sanitizeMessage(message: string): SafeHtml {
  return this.sanitizeService.sanitizeMessage(message,this.highlightText,true);
 }
 onSaveClick(){
  this.updateDocument();
 }

onCancelRemark() {
  this.displayRemarkPopup = false;
  this.remark = '';
}
 updateDocument() {
  if(this.selectedfilecontent.content==this.editableDocument.content){
    this.messageService.add({ severity: 'warn', summary: 'No Changes Detected', 
      detail: 'No changes were made to the document. Please make edits before saving.'  });
  }
  else{
  let payload = {
    "content": this.editableDocument.content
  };
  
  this.api.putMethod(`document/${this.collectionId}/${this.documentId}`, payload).subscribe({
    next: (response: any) => {
      this.syncDocument();
      this.messageService.add({ severity: 'success', detail: response.message });
      this.remark = '';
    },
    error: (error: any) => {
      console.error('Error updating document', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
      this.modalloader = false;
    },
    complete:()=>{
      this.fetchFilecontent(this.documentId,false);
      this.getVersion()
    }
  });
}
 }
syncDocument() {   
  let payload = {};
  this.api.singleFileSyncMethod(this.documentName,this.selectedfilecontent.file_name, payload).subscribe({
    next: (response: any) => {
      this.messageService.add({ severity: 'success', detail: response.message });
    },
    error: (err) => {
      console.error('Error while syncing', err);
      this.messageService.add({ severity: 'error', detail: err.error.detail });
    },
    complete: () => { }
  });
}
collapseLeftNav(){
  this.showleftMenu=!this.showleftMenu;
}
goToCollection(){
  this.router.navigate(["/collection",this.documentName])
}
fnBookmark(){
  let body={};
  this.api.postMethod(`document/bookmark/${this.documentId}`,body).subscribe({
    next: (response: any) => {
      if(response.data.bookmarkSave==true){
      this.isbookmarked=true
      }else{this.isbookmarked=false}   ;
      this.messageService.add({ severity: 'success', detail: response.message });
   this.fetchDocuments();
    },
    error: (error: any) => {
      console.error('Error updating document', error);
    }
});
}
getKnowledgegapQn(){
  let body={"answerLenght": 500}
  this.api.getWithParams(`document/KnowledgeGap/${this.collectionId}/${this.documentId}`,body).subscribe({
    next: (response: any) => {
      this.knowledgegpaDetail=response.data;      
    },
    error: (error: any) => {
      console.error('Error updating document', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
    }
});
}
generateAnswers(){
  let body={"answerLenght": 500}
  this.api.getWithParams(`document/generativeQuestion/${this.collectionId}/${this.documentId}`,body).subscribe({
    next: (response: any) => {
      this.generateqns=response.data.questions;      
    },
    error: (error: any) => {
      console.error('Error updating document', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
    }
});   
}
getVersion(){
  this.api.getMethod(`document/versions/${this.collectionId}/${this.documentId}`).subscribe({
    next: (response: any) => {
       this.versionDetail=response.data;      
    },
    error: (error: any) => {
      console.error('Error updating document', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
    }
});   
}
getAuditlog(){
  this.api.getMethod(`document/auditLogs/${this.collectionId}/${this.documentId}`).subscribe({
    next: (response: any) => {
       this.auditDetail=response.data;      
    },
    error: (error: any) => {
      console.error('Error updating document', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
    }
});
}
uploadDoc(event: Event,collection_name:any){
  event.stopPropagation();
  this.showuploadmodal = true
  this.collection_to_upload_doc = collection_name
}
handleFileSelection(selectedFiles:any){
  this.files = [...this.files, ...selectedFiles];
}
handleFileDelete(file:any){
  const filesArray = Array.from(this.files);

// Find the index of the file in the array
  const index = filesArray.findIndex(f => f === file);
  if (index !== -1) {
    filesArray.splice(index, 1);
    this.files = filesArray
  }
}
handleFileUpload(){
  const token = localStorage.getItem('token');
  if (!token || !this.files.length || !this.collection_to_upload_doc) {
    this.messageService.add({ severity: 'warn', summary: 'Invalid Data', detail: 'Please make sure to select files and provide a valid collection name.' });
    return;
  }

  this.uploadloader = true;

  this.api.uploadFiles(this.collection_to_upload_doc, this.files, token).subscribe({
    next: (response: any) => {
      this.showuploadmodal = false;
      this.uploadloader = false;

      response.forEach((file: any) => {
        const fileName = file.name;
        
        if (file.isDuplicateFile) {
          this.messageService.add({ 
            severity: 'warn', 
            summary: 'Duplicate File', 
            detail: `${fileName} is a duplicate file and was not uploaded.` 
          });
        } else if (file.isFileUploadedOnS3) {
          this.messageService.add({ 
            severity: 'success', 
            summary: 'File Uploaded', 
            detail: `${fileName} uploaded successfully.` 
          });
        } else {
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Upload Failed', 
            detail: `${fileName} could not be uploaded to S3.` 
          });
        }
      });
    },
    error: (error:any) => {
      console.error('upload-collection-files', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
      this.uploadloader = false;
    }
  });
}
getRlatedDoc(){
  this.api.getMethod(`document/getRelatedDocument/${this.collectionId}/${this.documentId}`).subscribe({
    next: (response: any) => {
       this.relatetedDocList=response.data;      
    },
    error: (error: any) => {
      console.error('Error updating document', error);
      this.messageService.add({ severity: 'error', detail: error.error.detail });
    }
});
}
deletedoc(id:any){
  if(this.collectionId){
let body={
  "collectionId": this.collectionId,
  "relatedDocumentId": [id]
}

this.api.deleteMethod("document/deleteRelatedDocument",body).subscribe({
next: (data) => {
  
  this.messageService.add({ severity: 'success', detail: data.message });
  this.getRlatedDoc();
},
error: (err) => {
  this.messageService.add({ severity: 'error', detail: err.message });
  console.error('DeleteError', err);
}
});}
}
addReleteDoc(){
this.showSelect=true;
this.api.getMethod(`document/getAllCollectionDocument/${this.collectionId}/${this.documentId}`).subscribe({
  next: (res) => {
    this.DocumentList = res.data.map((doc: any) => {
      return { label: doc.file_name, value: doc.id };
    })
  },
  error: (err) => {
    this.messageService.add({ severity: 'error', detail: err.message });
    console.error('getFileError', err);
  }
  });
}
saveSelection(){
  const selectedDocumentIds = this.selectedDocuments.map((doc: any) => doc.value);
  let payload={
    "collectionId": this.collectionId,
    "parentDocumentId": this.documentId,
    "childDocumentIds":selectedDocumentIds
  }
  this.api.postMethod(`document/addRelatedDocument`,payload).subscribe({
    next: (res) => {
      this.getRlatedDoc()
      this.messageService.add({ severity: 'success', detail: res.message });
      this.showSelect=false;
    },
    error: (err) => {
      this.messageService.add({ severity: 'error', detail: err.message });
      console.error('PostError', err);
      this.showSelect=false;
    }
    });
}
closeselectModal(){
  this.showSelect=false;
  this.selectedDocuments=[];
}
fetchStatus(){
  this.api.getMethod(`document/status`).subscribe({
    next: (res) => {
      this.statuses = res.data;
    },
    error: (err) => {
      this.messageService.add({ severity: 'error', detail: err.message });
      console.error('Error in fetching status', err);
   
    }
});
}
applyFilters() {
  this.searchTerm='';
  this.loader = true; 
  this.fetchDocuments();
}
viewVersion(versionId:any,viewmode:boolean){
 this.viewversion=viewmode;
 this.selectedVersionfilecontent = '';
 this.versionmodalloader=viewmode;
 this.versionId=versionId;
 this.api.getMethod(`document/view/version/${this.versionId}`).subscribe({
  next: (res) => {
    this.versionmodalloader = false;
    this.selectedVersionfilecontent = res.data;
    if(viewmode==false){
      this.onDownload(this.selectedVersionfilecontent.content,'txt');
    }
  },
  error: (err) => {
    this.messageService.add({ severity: 'error', detail: err.error.message });
    console.error('Error in fetching status', err);
 
  }
});
}
onDialogHideaddcollection(){
  this.viewversion=false;
}
openReldoc(data:any){
  window.location.href = `/collection/${this.documentName}/document/${ data.childDocument.slug}`;
  const dataToPass = { documentId: data.document_id, collectionId: this.collectionId };
   this.api.setData(dataToPass);
}
downloadRTFFile() {
  const content = this.content.nativeElement.innerText; // Yeh aapke HTML ka reference hai
  const file = new Blob([content], { type: 'text/plain' });
  const element = document.createElement('a');
  element.href = URL.createObjectURL(file);
  element.download = `${this.file_name}`;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);


}


onDownload(answer:Blob,format: 'pdf' | 'docx' | 'txt') {
// this.sanitizeService.downloadAnswer(answer,format,this.documentName);

  const element = this.content.nativeElement;
  
  html2canvas(element,{ useCORS: true }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save(`${this.file_name}`);
  });


}
getAbsoluteUrl(questionId: number): string {
  const tree = this.router.createUrlTree(['/faq'], { queryParams: { questionid: questionId } });
  return `${window.location.origin}${this.router.serializeUrl(tree)}`;
}
viewQuest(questionId:number){
  const url = this.getAbsoluteUrl(questionId);
  window.open(url, '_blank');
}
getkeywordSearch(){
  this.api.getMethod(`api/v1/elasticsearch/document/oneinsightdocuments/logs/${this.documentId}`).subscribe({
    next: (res) => {
      this.keywordSearchlogs=res.data
    },
    error: (err) => {
      this.messageService.add({ severity: 'error', detail: err.error.message });
      console.error('Error in keyword searchlog ', err);
    }
  })  
}
}